import ActionWithPayload from 'moduleBase/reducers/types/ActionWithPayload';
import { APP_INIT_RECEIVE, APP_USER_LOAD_BALANCE_SUCCESS } from 'moduleBase/constants';
import { AppInitReceivePayloadType } from 'moduleBase/actions/types/AppInitReceivePayloadType';
import { StateType } from 'moduleBase/modules/menu-balance/types/StateType';
import { UserLoadBalanceResponseType } from 'moduleBase/actions/types/UserLoadBalanceResponseType';
import { MENU_BALANCE_LOAD_SUCCESS } from 'moduleBase/modules/menu-balance/constants';
import { LoadSuccessPayloadType } from 'moduleBase/modules/menu-balance/actions/types/LoadSuccessPayloadType';

// eslint-disable-next-line default-param-last
const reducerMenuBalance = (state: StateType = {}, action: ActionWithPayload): StateType => {
  switch (action.type) {
    case APP_INIT_RECEIVE: {
      const payload = action.payload as AppInitReceivePayloadType;
      return {
        ...state,
        menu: payload.balanceMenu,
      };
    }
    case APP_USER_LOAD_BALANCE_SUCCESS: {
      const payload = action.payload as UserLoadBalanceResponseType;
      return {
        ...state,
        menu: {
          ...state.menu,
          wait: payload.wait,
          frozen: payload.frozen,
        },
      };
    }
    case MENU_BALANCE_LOAD_SUCCESS: {
      const payload = action.payload as LoadSuccessPayloadType;
      return {
        ...state,
        menu: payload.menu,
      };
    }
    default:
      return state;
  }
};

export { reducerMenuBalance };
